import script from "./ProgressTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressTable.vue?vue&type=script&setup=true&lang=js"

import "./ProgressTable.vue?vue&type=style&index=0&id=34652ccb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34652ccb"]])

export default __exports__